export const claim = [
  {
    id: "Y",
    name: "청구",
  },
  {
    id: "N",
    name: "미청구",
  },
];

export const irbTask = [
  {
    id: "1",
    name: "초기심의 (Initial)",
  },
  {
    id: "2",
    name: "변경심의 (Major Amendment)",
  },
  {
    id: "3",
    name: "변경심의 (Minor Amendment)",
  },
  {
    id: "4",
    name: "결과보고 (CSR)",
  },
  {
    id: "5",
    name: "종료보고 (Completion)",
  },
  {
    id: "6",
    name: "결과보고 (CSR)",
  },
  {
    id: "7",
    name: "임상시험계획서 위반보고 (Protocol Deviation)",
  },
  {
    id: "8",
    name: "기타보고 (Others)",
  },
];

export const detailedCmt = [
  {
    id: "1",
    name: "초기심의(Initial)",
  },
  {
    id: "2",
    name: "변경심의(Amendment)",
  },
  {
    id: "3",
    name: "지속심의(Interim)",
  },
  {
    id: "4",
    name: "종료보고(Completion)",
  },
  {
    id: "5",
    name: "결과보고(CSR)",
  },
];

export const siteVisitTask = [
  {
    id: "01",
    name: "Pre-Study Visits (PSV) - Remote",
  },
  {
    id: "02",
    name: "Pre-Study Visits (PSV) - On-site",
  },
  {
    id: "03",
    name: "Site Initiation Visit (SIV) - Remote",
  },
  {
    id: "04",
    name: "Site Initiation Visit (SIV) - On-site",
  },
  {
    id: "05",
    name: "Site Monitoring Visit (SMV) - Remote",
  },
  {
    id: "06",
    name: "Site Monitoring Visit (SMV) - On-site",
  },
  {
    id: "07",
    name: "Site Close-out Visit (SCV) - Remote",
  },
  {
    id: "08",
    name: "Site Close-out Visit (SCV) - On-site",
  },
  {
    id: "09",
    name: "Site Additional Visit (SAV) - Remote",
  },
  {
    id: "10",
    name: "Site Additional Visit (SAV) - On-site",
  },
];

export const NY = [
  {
    id: "N",
    name: "No",
  },
  {
    id: "Y",
    name: "Yes",
  },
];

export const clinicalSiteStepType = [
  {
    id: "1",
    name: "SUB-I",
  },
  {
    id: "2",
    name: "CRC",
  },
  {
    id: "3",
    name: "CRA",
  },
];
